import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { LetDirective } from '@ngrx/component';

import { WishlistSaveButtonModule } from '../wishlist-save-button/wishlist-save-button.module';

import { NbaBarComponent } from './nba-bar.component';
import { NbaSecondaryItemComponent } from './nba-secondary-item/nba-secondary-item.component';
import { NbaService } from './nba.service';

@NgModule({
  imports: [CommonModule, WishlistSaveButtonModule, LetDirective, NbaBarComponent, NbaSecondaryItemComponent],
  exports: [NbaBarComponent],
  providers: [NbaService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NbaBarModule {}
